import type { HotelReservation, HotelReservationBookInput, HotelReservationQuoteInput } from '@bandido/shared/types';
import { client } from '@frontend/features/common/services';

export const hotelReservationTransport = {
  async quote(input: HotelReservationQuoteInput, connectionAgencyId?: number): Promise<HotelReservation> {
    return (
      await client.post<HotelReservation>(
        'hotels/bookings/quote',
        input,
        connectionAgencyId === undefined ? undefined : { headers: { 'Resource-Agency-Id': String(connectionAgencyId) } },
      )
    ).data;
  },
  async cancel(id: string): Promise<HotelReservation> {
    return (await client.post<HotelReservation>(`hotels/bookings/${encodeURIComponent(id)}/cancel`)).data;
  },
  async previewReconciliation(id: string, supplierReference: string, reason: string): Promise<HotelReservation> {
    return (await client.post<HotelReservation>(`hotels/bookings/${encodeURIComponent(id)}/reconciliation`, { supplierReference, reason })).data;
  },
  async confirmReconciliation(id: string, jobId: string): Promise<HotelReservation> {
    return (await client.post<HotelReservation>(`hotels/bookings/${encodeURIComponent(id)}/reconciliation/confirm`, { jobId })).data;
  },
  async sync(id: string): Promise<HotelReservation> {
    return (await client.post<HotelReservation>(`hotels/bookings/${encodeURIComponent(id)}/sync`)).data;
  },
  async read(id: string): Promise<HotelReservation> {
    return (await client.get<HotelReservation>(`hotels/bookings/${encodeURIComponent(id)}`)).data;
  },
  async book(id: string, input: HotelReservationBookInput): Promise<HotelReservation> {
    return (await client.post<HotelReservation>(`hotels/bookings/${encodeURIComponent(id)}/book`, input)).data;
  },
};
